import { GreyContainer } from 'shared/ui';
import moment from 'moment/moment';
import classes from './Notification.module.css';
import { Typography, Button } from 'antd';
import { FC } from 'react';
import { CloseOutlined } from '@ant-design/icons';

type NotificationProps = {
  id: number;
  title: string;
  text: string;
  date: string;
  unread?: boolean;
  onClick: () => void;
  onDelete?: (id: number) => void;
}

const NotificationItem: FC<NotificationProps> = ({ id, title, text, date, unread, onClick, onDelete }) => {
  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(id);
    }
  };

  const deleteAction = onDelete ? (
    <Button
      type="text"
      icon={<CloseOutlined />}
      onClick={handleDelete}
      style={{ 
        color: '#ff4d4f',
        padding: '4px 8px',
        height: 'auto',
        minWidth: 'auto'
      }}
      size="small"
    />
  ) : undefined;

  return (
    <GreyContainer
      id="notification"
      className={classes.notification}
      title={title}
      onClick={onClick}
      action={deleteAction}
    >
      <Typography.Text
        id="notification-text"
        className={`${classes.notification__text}`}
      >
        {text}
      </Typography.Text>
      <Typography.Text className={classes.notification__timestamp}>{moment(date, 'DD-MM-YYYY hh:mm:ss').format('DD MMMM YYYY, hh:mm a')}</Typography.Text>
    </GreyContainer>
  );
}

export default NotificationItem;